import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import AboutCompMusicWars from "../component/HomeLayout/homeOne/AboutMusicWars";
import FooterThree from "../component/footer/FooterThree";
import BreadcrumbNeodinamika from "./common/BreadcrumbNeodinamika";

class MusicWars extends Component{
    render(){
        return(
            <React.Fragment>
                {/*было About*/}
                <PageHelmet pageTitle='Music Wars' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <BreadcrumbNeodinamika title={'Music Wars'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area */}
                <div className="about-area ptb--80 bg_color--1">
                    <AboutCompMusicWars />
                </div>
                {/* End About Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area attacment-fixed rn-finding-us ptb--80 bg_color--1 bg_image bg_image--18" data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2">
                                <div className="inner">
                                    <div className="content-wrapper">
                                        <div className="content">
                                            <h4 className="theme-gradient">Попробуй себя в деле</h4>
                                            <p>В завершении распродажи в Саунд Сити привезли особенные подарки. В них можно найти все артефакты весны, а также обнаружить заветный артефакт - Крионизатор! Не упустите уникальный шанс стать обладателями самых полезных артефактов майской распродажи.</p>
                                            <a className="btn-default" href="https://musicwars.ru/" target="_blank" rel="noopener noreferrer">Играть</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                {/*<Footer />*/}
                <FooterThree />

            </React.Fragment>
        )
    }
}
export default MusicWars
